import type { NewsItem } from '@/mocks/news';
import SectionHeading from '@/components/base/SectionHeading';
import NewsCard from '@/components/base/NewsCard';

type LatestNewsProps = {
  items: NewsItem[];
};

export default function LatestNews({ items }: LatestNewsProps) {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        title="最新电影资讯"
        subtitle="票房动态、影片消息与行业观察，第一时间掌握影坛变化"
        moreTo="/news"
        moreLabel="更多资讯"
      />
      {items.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-100 py-12 text-center text-sm text-foreground-500">
          暂无相关内容，敬请期待
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="lg:sticky lg:top-20">
            <NewsCard item={items[0]} variant="grid" />
          </div>
          <div className="flex flex-col gap-4">
            {items.slice(1, 5).map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
}